export default __webpack_public_path__ + "static/media/phoneIcon.62dfa086.png";